import { useMemo} from 'react';
import { yyyyMMddHHmmssToOtherFormat } from '@bo-utils/dateUtils';

const usePoPrivacyPolicyContent = (contents) => {
  
const poPrivacyPolicyContent = useMemo ( 
  () => contents?.map((item) => (
    {
      label: `${yyyyMMddHHmmssToOtherFormat(item?.applyStartDateTime, 'yyyy-MM-dd')}`,
      key: `${yyyyMMddHHmmssToOtherFormat(item?.applyStartDateTime, 'yyyyMMdd')}`,
      value: `${item?.termsContent}`, 
    }
    )),
    [contents]
);

  return {
    poPrivacyPolicyContent,
  };

};

export default usePoPrivacyPolicyContent;

